
export class TrendViewModel {
  Id: number = 0;
  IconId: number = 0;
  Name: string = "";
  Color: string = "#50f150";
  Source: string = "";
  DataType: number = 0;
  Flags: string = "";
  MinScale: number = 0;
  MaxScale: number = 100;
  LowAlarm: number = null;
  HighAlarm: number = null;
  Units: string = "";
  SmoothCount: number = 0;
  CalibrationTable: CalibartionValue[] = [];
  TrendBindingHistory: TrendBindingHistory[] = [];
  OnText: string = "";
  OffText: string = "";

  MinRawValue: number = null;
  MaxRawValue: number = null;
  ValueCalcFormula: string = "";
  OrderNumber: number;
  init(data?: any) {
    if (data) {
      this.Id = data["id"];
      this.IconId = data["iconId"];
      this.Name = data["name"];
      this.Color = data["color"];
      this.DataType = data["dataType"];
      this.Flags = data["flags"];
      this.MinScale = data["minScale"];
      this.MaxScale = data["maxScale"];
      this.LowAlarm = data["lowAlarm"] ?? null;
      this.HighAlarm = data["highAlarm"] ?? null;
      this.Units = data["units"];
      this.SmoothCount = data["smoothCount"];
      this.OnText = data["onText"];
      this.OffText = data["offText"];

      this.MinRawValue = data["minRawValue"] ?? null;
      this.MaxRawValue = data["maxRawValue"] ?? null;
      this.ValueCalcFormula = data["valueCalcFormula"];
      this.OrderNumber = data["orderNumber"];

      this.Source = data["source"];
      let points = data["calibrationTable"];
      if (points && points.constructor === Array)
        for (let item of points)
          this.CalibrationTable.push(CalibartionValue.fromJS(item))

      let binding = data["trendBindingHistory"];
      if (binding && binding.constructor === Array)
        for (let item of binding)
          this.TrendBindingHistory.push(TrendBindingHistory.fromJS(item))
    }
  }

  static fromJS(data: any): TrendViewModel {
    data = typeof data === 'object' ? data : {};
    let result = new TrendViewModel();
    result.init(data);
    return result;
  }
}

export class TrendBindingHistory {
  Input: string = "";
  Time: number;

  init(data?: any) {
    if (data) {
      this.Input = data["input"];
      this.Time = data["time"];
    }
  }

  static fromJS(data: any): TrendBindingHistory {
    data = typeof data === 'object' ? data : {};
    let result = new TrendBindingHistory();
    result.init(data);
    return result;
  }
}

export class InputViewModel {
  Id: string;
  Name: string;
  AvailableNumbers: number = 0;

  constructor(Id: string, Name: string, AvailableNumbers?: number) {
    this.Id = Id;
    this.Name = Name;
    this.AvailableNumbers = AvailableNumbers ? AvailableNumbers : 0;
  }
}

export class ExportCalibartionValue {
  SensorValue: number;
  TrendValue: number;
  Title: string;
}

export class CalibartionValue {
  RawValue: number;
  Value: number;
  Title: string;

  init(data?: any) {
    if (data) {
      this.RawValue = data["rawValue"];
      this.Value = data["value"];
      this.Title = data["title"];
    }
  }

  static fromJS(data: any): CalibartionValue {
    data = typeof data === 'object' ? data : {};
    let result = new CalibartionValue();
    result.init(data);
    return result;
  }
}
